export default function DisplayNFTCount({remainingNFTs, currentAccount}){
    console.log("Remain: ", remainingNFTs)
    if(currentAccount===""){
        return <div></div>
    }
    if(remainingNFTs===0){
        return <div className="nftcounter">No NFTs is left to be minted.</div>
    }else{
        return <div className="nftcounter">{remainingNFTs} NFTs is left to be minted.</div>
    }
}